const DEV_URL = 'https://localhost:5001'; // local
// const DEV_URL = 'http://10.0.10.54:5000'; // VM Mobile
export const isDemoEnv = import.meta.env.VITE_NODE_ENV === 'demo';
export const isDevEnv = import.meta.env.VITE_NODE_ENV === 'dev';
export const isDevelopmentEnv = import.meta.env.VITE_NODE_ENV === 'development';
export const isProductionEnv = import.meta.env.VITE_NODE_ENV === 'production';
export const isStagingEnv = import.meta.env.VITE_NODE_ENV === 'staging';
export const isOnlineEnv = import.meta.env.VITE_NODE_ENV !== 'development';

export const ARMADO_URL = isOnlineEnv ? location.origin : DEV_URL;

export const DOCUMENT_EXTENSION = {
	'application/zip': '.zip',
	'application/pdf': '.pdf',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
};

export const ONBOARDING = {
	Order: 'tourOrder',
	OrderDetails: 'tourOrderDetails',
	JobOffer: 'tourJobOffer',
};

export const HELP = {
	List: 0,
	Signature: 1,
	Command: 2,
	RecordHour: 4,
	ContractProlongation: 8,
	DigitalSafe: 16,
	Role: 32,
	Tag: 64,
};

export const SUITE_URL = import.meta.env.VITE_SUITE_URL;
